import React from 'react'
import MaterialSymbol from '../material-symbol'

const LightMode = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="light_mode" {...props} />
))

LightMode.displayName = 'LightMode'

export default LightMode
